import { ClientCollection } from "..";

class AbstractCategoryCollection extends ClientCollection {}

export { AbstractCategoryCollection };